import React from "react";
import { motion } from "framer-motion";
import { FaUsers, FaTruck, FaCog } from "react-icons/fa";

function Features() {
  return (
    <section className="features">
      <div className="container">
        <div className="features-grid">
          <motion.div
            className="feature-item"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="feature-icon">
              <FaUsers />
            </div>
            <h3>Expert Team</h3>
            <p>Experienced professionals led by Mr. Parth Patel</p>
          </motion.div>

          <motion.div
            className="feature-item"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="feature-icon">
              <FaTruck />
            </div>
            <h3>Fast Delivery</h3>
            <p>Strong logistic support ensuring timely delivery</p>
          </motion.div>

          <motion.div
            className="feature-item"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="feature-icon">
              <FaCog />
            </div>
            <h3>Quality Assured</h3>
            <p>Rigorous quality control and testing processes</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Features;
